var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{staticClass:"style3 specialOffers",attrs:{"title":"Special Offers"}},[_vm._v("Offers")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }